import { useState } from "react";

const WA_LINK = "https://wa.me/5581995913182?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20meu%20benef%C3%ADcio%20previdenci%C3%A1rio";

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 cursor-pointer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="Fale pelo WhatsApp"
    >
      {/* Tooltip */}
      <div
        className={`text-white font-body text-xs font-medium px-3 py-2 rounded-lg whitespace-nowrap transition-all duration-300 ${
          hovered ? "opacity-100 translate-x-0" : "opacity-0 translate-x-4 pointer-events-none"
        }`}
        style={{ backgroundColor: "rgb(61, 35, 32)" }}
      >
        Fale pelo WhatsApp
      </div>

      {/* Button */}
      <div className="relative">
        <span
          className="absolute inset-0 rounded-full animate-ping opacity-20"
          style={{ backgroundColor: "#7A2C1E" }}
        />
        <div
          className="relative w-14 h-14 flex items-center justify-center rounded-full transition-colors duration-300"
          style={{ backgroundColor: hovered ? "rgb(61, 35, 32)" : "#7A2C1E" }}
        >
          <i className="ri-whatsapp-line text-white text-2xl" />
        </div>
      </div>
    </a>
  );
}
